/**
 * Service Worker Registration
 * Registra el SW con manejo de actualizaciones seguras.
 * Evita "romper" la app con skipWaiting controlado.
 */

/**
 * Registra el Service Worker
 * @param {string} [swPath='/sw.js'] - Ruta al archivo SW
 * @returns {Promise<ServiceWorkerRegistration|null>}
 */
export const register = async (swPath = '/sw.js') => {
  if (!('serviceWorker' in navigator)) {
    console.log('[SW] ℹ️ Service Workers no soportados en este navegador');
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register(swPath);
    
    console.log('[SW] ✅ Registrado correctamente:', registration.scope);
    
    // Manejo de actualizaciones
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      
      console.log('[SW] 🔄 Nueva versión disponible');
      
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // Hay una nueva versión esperando para activar
          console.log('[SW] 📦 Nueva versión lista para activar');
          
          // Mostrar UI de actualización (opcional)
          showUpdateNotification(newWorker);
        }
      });
    });
    
    // Escuchar mensajes del SW (ej: cache updated)
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'CACHE_UPDATED') {
        console.log('[SW] 📦 Cache actualizado:', event.data.payload);
      }
    });
    
    return registration;
    
  } catch (error) {
    console.error('[SW] ❌ Error al registrar:', error);
    return null;
  }
};

/**
 * Muestra notificación de actualización disponible
 * @param {ServiceWorker} worker 
 */
const showUpdateNotification = (worker) => {
  // Emitir evento para que la UI muestre notificación
  window.dispatchEvent(new CustomEvent('sw:update-available', {
    detail: { worker }
  }));
  
  // Auto-skipWaiting para desarrollo (comentar en prod si se quiere confirmación)
  // worker.postMessage({ type: 'SKIP_WAITING' });
};

/**
 * Fuerza la actualización del SW (skipWaiting)
 * Útil para "Actualizar ahora" button
 */
export const forceUpdate = async () => {
  const registration = await navigator.serviceWorker?.ready;
  if (registration?.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
};

/**
 * Verifica si hay una nueva versión disponible
 * @returns {Promise<boolean>}
 */
export const checkForUpdates = async () => {
  const registration = await navigator.serviceWorker?.ready;
  if (registration) {
    await registration.update();
    return !!registration.waiting;
  }
  return false;
};
